import { Container } from "@mui/material";
import MKButton from "components/MKButton";
import TAFilterMenu from "../TAFilterMenu";
import React, { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// Pass these values into the search filter
const filterMenuOptions = [
  // {
  //   name: "Licensed To Practice In",
  //   label: "Sort by State",
  //   type: "select",
  //   options: [
  //     { value: "All", label: "All" },
  //     { value: "Alabama", label: "Alabama" },
  //     { value: "Alaska", label: "Alaska" },
  //     { value: "Arizona", label: "Arizona" },
  //     { value: "Arkansas", label: "Arkansas" },
  //     { value: "California", label: "California" },
  //     { value: "Colorado", label: "Colorado" },
  //     { value: "Connecticut", label: "Connecticut" },
  //     { value: "Delaware", label: "Delaware" },
  //     { value: "Florida", label: "Florida" },
  //     { value: "Georgia", label: "Georgia" },
  //     { value: "Hawaii", label: "Hawaii" },
  //     { value: "Idaho", label: "Idaho" },
  //     { value: "Illinois", label: "Illinois" },
  //     { value: "Indiana", label: "Indiana" },
  //     { value: "Iowa", label: "Iowa" },
  //     { value: "Kansas", label: "Kansas" },
  //     { value: "Kentucky", label: "Kentucky" },
  //     { value: "Louisiana", label: "Louisiana" },
  //     { value: "Maine", label: "Maine" },
  //     { value: "Maryland", label: "Maryland" },
  //     { value: "Massachusetts", label: "Massachusetts" },
  //     { value: "Michigan", label: "Michigan" },
  //     { value: "Minnesota", label: "Minnesota" },
  //     { value: "Mississippi", label: "Mississippi" },
  //     { value: "Missouri", label: "Missouri" },
  //     { value: "Montana", label: "Montana" },
  //     { value: "Nebraska", label: "Nebraska" },
  //     { value: "Nevada", label: "Nevada" },
  //     { value: "New Hampshire", label: "New Hampshire" },
  //     { value: "New Jersey", label: "New Jersey" },
  //     { value: "New Mexico", label: "New Mexico" },
  //     { value: "New York", label: "New York" },
  //     { value: "North Carolina", label: "North Carolina" },
  //     { value: "North Dakota", label: "North Dakota" },
  //     { value: "Ohio", label: "Ohio" },
  //     { value: "Oklahoma", label: "Oklahoma" },
  //     { value: "Oregon", label: "Oregon" },
  //     { value: "Pennsylvania", label: "Pennsylvania" },
  //     { value: "Rhode Island", label: "Rhode Island" },
  //     { value: "South Carolina", label: "South Carolina" },
  //     { value: "South Dakota", label: "South Dakota" },
  //     { value: "Tennessee", label: "Tennessee" },
  //     { value: "Texas", label: "Texas" },
  //     { value: "Utah", label: "Utah" },
  //     { value: "Vermont", label: "Vermont" },
  //     { value: "Virginia", label: "Virginia" },
  //     { value: "Washington", label: "Washington" },
  //     { value: "West Virginia", label: "West Virginia" },
  //     { value: "Wisconsin", label: "Wisconsin" },
  //     { value: "Wyoming", label: "Wyoming" },
  //   ],
  //   multi: false,
  // },
  {
    name: "Specialties",
    label: "Search by Specialty",
    type: "select",
    options: [
      { value: "All", label: "All" },
      { value: "Addictions", label: "Addictions" },
      { value: "Anxiety", label: "Anxiety" },
      { value: "Bi-polar", label: "Bi-polar" },
      { value: "Depression", label: "Depression" },
      { value: "Eating Disorders", label: "Eating Disorders" },
      { value: "OCD", label: "OCD" },
      { value: "PTSD", label: "PTSD" },
      { value: "Panic Disorders", label: "Panic Disorders" },
      { value: "Personality Disorders", label: "Personality Disorders" },
      { value: "Phobias", label: "Phobias" },
      { value: "Sexual Disorders", label: "Sexual Disorders" }
    ]
    ,
    multi: false,
  },
  {
    name: "Types Of Therapy",
    label: "Search by Therapy Options",
    type: "select",
    multi: false,
    options: [
      { value: "All", label: "All" },
      { value: "Acceptance and Commitment", label: "Acceptance and Commitment" },
      { value: "Adlerian", label: "Adlerian" },
      { value: "Art", label: "Art" },
      { value: "Attachment", label: "Attachment" },
      { value: "Behavioral", label: "Behavioral" },
      { value: "Bibliotherapy", label: "Bibliotherapy" },
      { value: "Biodynamic", label: "Biodynamic" },
      { value: "Brain Stimulation", label: "Brain Stimulation" },
      { value: "Christian-Based", label: "Christian-Based" },
      { value: "Cognitive", label: "Cognitive" },
      { value: "Coherence", label: "Coherence" },
      { value: "Couples", label: "Couples" },
      { value: "Culturally Sensitive", label: "Culturally Sensitive" },
      { value: "Existential", label: "Existential" },
      { value: "Exposure", label: "Exposure" },
      { value: "Family", label: "Family" },
      { value: "Group", label: "Group" },
      { value: "Humanistic", label: "Humanistic" },
      { value: "Integrative/Holistic", label: "Integrative/Holistic" },
      { value: "Interpersonal", label: "Interpersonal" },
      { value: "Mentalization", label: "Mentalization" },
      { value: "Mindfulness", label: "Mindfulness" },
      { value: "Psychoanalysis", label: "Psychoanalysis" },
      { value: "Psychodynamic", label: "Psychodynamic" }
    ]
    ,
  },

  {
    name: "Treatment Methods",
    label: "Search by Treatment Methods",
    type: "select",
    multi: false,
    options: [
      { value: "All", label: "All" },
      { value: "ACT", label: "ACT" },
      { value: "CBT", label: "CBT" },
      { value: "DBT", label: "DBT" },
      { value: "Ego State/Parts Work", label: "Ego State/Parts Work" },
      { value: "IFS", label: "IFS" },
      { value: "Supportive Psychotherapy", label: "Supportive Psychotherapy" },
      { value: "Psychodynamic Psychotherapy", label: "Psychodynamic Psychotherapy" },
    ],
  },
  {
    name: "Languages",
    label: "Search by Language",
    type: "select",
    options: [
      { value: "All", label: "All" },
      { value: "Arabic", label: "Arabic" },
      { value: "Bengali", label: "Bengali" },
      { value: "Dutch", label: "Dutch" },
      { value: "English", label: "English" },
      { value: "French", label: "French" },
      { value: "German", label: "German" },
      { value: "Greek", label: "Greek" },
      { value: "Hebrew", label: "Hebrew" },
      { value: "Hindi", label: "Hindi" },
      { value: "Italian", label: "Italian" },
      { value: "Japanese", label: "Japanese" },
      { value: "Korean", label: "Korean" },
      { value: "Mandarin", label: "Mandarin" },
      { value: "Polish", label: "Polish" },
      { value: "Portuguese", label: "Portuguese" },
      { value: "Russian", label: "Russian" },
      { value: "Spanish", label: "Spanish" },
      { value: "Swedish", label: "Swedish" },
      { value: "Thai", label: "Thai" },
      { value: "Turkish", label: "Turkish" },
      { value: "Urdu", label: "Urdu" },
      { value: "Vietnamese", label: "Vietnamese" }
]
,
    multi: false,
  },
  {
    name: "Visit Types",
    label: "Search by Visit Types",
    type: "select",
    multi: false,
    options: [
      { value: "All", label: "All" },
      { value: "In Person", label: "In Person" },
      { value: "Virtual", label: "Virtual" },
    ],
  },
  // {
  //     name: "verified",
  //     label: "Verified Therapists",
  //     type: "select",
  //     options: [
  //         { value: "All", label: "All" },
  //         { value: "active directory therapist", label: "Verified" },
  //     ],
  //     multi: false,

  // },
];

const SearchFilter = ({disabled}) => {
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  
  return (
    <>
      <Container sx={{ width: "auto !important", margin: "1rem 0rem" }}>
        <MKButton
          variant="contained"
          color="secondary"
          onClick={() => setShowAdvancedSearch(!showAdvancedSearch)}
          boxShadow="3"
          sx={{ height: "44.13px", borderRadius: "0.5rem", padding: ".5rem 1rem!important" }}
        >
          {showAdvancedSearch ? (
            <>
              Advanced Filters
              <ArrowDropUpIcon sx={{ height: "2rem", width: "2rem" }} />
            </>
          ) : (
            <>
              Advanced Filters
              <ArrowDropDownIcon sx={{ height: "2rem", width: "2rem" }} />
            </>
          )}
        </MKButton>
      </Container>
      {showAdvancedSearch ? <TAFilterMenu setShowAdvancedSearch={setShowAdvancedSearch} filterMenuOptions={filterMenuOptions} disabled={disabled} /> : null}
    </>
  );
};

export default SearchFilter;
